import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRouteSnapshot, NavigationEnd } from '@angular/router';

import { LanguageHelper, StateStorageService } from '../../shared';

// Including library as a raw JS file is required
// due to incorrect Webpack globals dependencies invocation
import * as BootstrapFileInput from '../../shared/third-party/bootstrap-fileinput@4.4.6/fileinput';

@Component({
    selector: 'qms-main',
    templateUrl: './main.component.html',
    styleUrls: [
        './main.component.css',
        '../../shared/third-party/bootstrap-fileinput@4.4.6/fileinput.css'
    ],
    encapsulation: ViewEncapsulation.None
})
export class MainComponent implements OnInit {

    // Instantiate object from Bootstrap File Input library
    // to force Webpack to include library's JS files
    private static FILE_INPUT_LIBRARY = BootstrapFileInput;

    private static PAGE_TITLE = 'pageTitle';

    constructor(private languageHelper: LanguageHelper,
                private router: Router,
                private $storageService: StateStorageService) {
    }

    private getPageTitle(routeSnapshot: ActivatedRouteSnapshot) {
        let title = '';

        if (routeSnapshot.data && routeSnapshot.data[MainComponent.PAGE_TITLE]) {
            title = routeSnapshot.data[MainComponent.PAGE_TITLE];
        }
        if (routeSnapshot.firstChild) {
            title = this.getPageTitle(routeSnapshot.firstChild) || title;
        }

        return title;
    }

    ngOnInit() {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                const title = this.getPageTitle(this.router.routerState.snapshot.root);
                if (title !== '') {
                    this.languageHelper.updateTitle();
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/main/main.component.ts